





























































































































































































































import loginMixin from '../mixin/loginMixin';
import LoginBtnComp from './LoginBtnComp.vue';
import LoginTitleComp from './LoginTitleComp.vue';

import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { Form as ElForm } from 'element-ui';
import { IRegister1, IRegister2 } from '@/interface/login';
import {
  sendEmailCodeApi,
  gearRegisterApi,
  getAllAreaCountryListApi,
  getByCountryIdApi,
  getByFkAreaStateIdApi,
} from '@/api/login';

@Component({
  name: 'registerFormComp',
  components: {
    LoginBtnComp,
    LoginTitleComp,
  },
})
export default class extends Mixins(loginMixin) {
  @Prop({ default: () => [] }) public countrys!: any;
  @Prop({ default: () => [] }) public phoneRegionOptions!: any;

  @Ref('stepOneForm') public stepOneFormRef!: ElForm;
  @Ref('stepTwoForm') public stepTwoFormRef!: ElForm;

  get countDownNumStr() {
    return this.countDownNum + ' s';
  }

  public loading = false;
  public getVerificationLoading = false;
  public isStepTwo = false;
  public countDownNum = 60;
  public countDownFlag = false;
  public countryOptions: any = [];
  public stateOptions: any = [];
  public cityOptions: any = [];
  public stepOneFormData: IRegister1 = {
    invitationCode: '',
    email: '',
    verification: '',
    loginPs: '',
    confirmPs: '',
    loginId: '',
  }
  public stepTwoFormData: IRegister2 = {
    name: '',
    gender: '',
    department: '',
    title: '',
    fkAreaCountryId: '',
    fkAreaStateId: '',
    fkAreaCityId: '',
    mobileAreaCode: '',
    mobile: '',
    fkPlatformType: 'get_issue',
    isGearSelfRegister: 1,
  };


  // 注册校验
  public stepOneFormRules = {
    invitationCode: [
      { required: true, message: this.$t('login.invitationCodeMsg'), trigger: 'blur' }
    ],
    email: [
      { required: true, message: this.$t('login.emailMsg'), trigger: 'blur' },
    ],
    verification: [
      { required: true, message: this.$t('login.verificationMsg'), trigger: 'blur' }
    ],
    loginPs: [
      { required: true, validator: this.validatePassword, trigger: 'blur'}
    ],
    confirmPs: [
      { required: true, validator: this.validatePassword, trigger: 'blur' },
      { validator: this.validateConfirmPs, trigger: 'blur' }
    ],
  };

  public stepTwoFormRules = {
    name: [{
      required: true, validator: this.validateInput(this.$t('login.applyPeopleNameMsg') + ''), trigger: 'blur',
    }],
    gender: [{
      required: true, message: this.$t('login.genderMsg'), trigger: 'blur',
    }],
    department: [{
      required: true, validator: this.validateInput(this.$t('login.departmentMsg') + ''), trigger: 'blur',
    }],
    position: [{
      required: true, validator: this.validateInput(this.$t('login.positionMsg') + ''), trigger: 'blur',
    }],
    mobile: [
      { required: true, message: this.$t('login.mobileMsg'), trigger: 'blur' },
      { validator: this.checkPhoneNumber, trigger: 'blur' },
    ],
    mobileAreaCode: [
      { required: true, message: this.$t('login.mobileAreaCodeMsg'), trigger: 'change' },
      { validator: this.checkPhoneRegion, trigger: 'change' },
    ],
  };

  public created() {
    this.getAllAreaCountryList();
  }

  public mounted() {
    const query: any = this.$route.query;
    if (query && query.invitcode) {
      this.stepOneFormData.invitationCode = query.invitcode;
    }
  }

  public checkPhoneNumber(rule: any, value: string, callback: any) {
    const mobileAreaCode = this.stepTwoFormData.mobileAreaCode;
    if (!mobileAreaCode) { return callback() };
    if (!this.phoneRegionValidate(mobileAreaCode, value)) {
      callback(new Error(this.$t('validate.phoneRegionValid') as string));
    } else {
      this.stepTwoFormRef.clearValidate('mobileAreaCode');
      callback();
    }
  }

  public checkPhoneRegion(rule: any, value: string, callback: any) {
    const mobile = this.stepTwoFormData.mobile;
    if (!mobile) { return callback() };
    const formRef = this.stepTwoFormRef as any;
    if (!this.phoneRegionValidate(value, mobile)) {
      formRef.validateField('mobile', callback(this.$t('validate.phoneRegionValid') as string));
      callback();
    } else {
      formRef.clearValidate('mobile');
      callback();
    }
  }

  public phoneRegionValidate(region: string, phone: string) {
    let phoneReg: RegExp | null = null;
    switch (region) {
      case '86': // 中国大陆：开头1 3-8号段，后边跟9位数字
        phoneReg = /^[1][3,4,5,7,8,9,6][0-9]{9}$/;
        break;
      case '852': // 5或9或6开头后面跟7位数字
        // phoneReg = /^([4|5|6|7|9])\d{7}$/;
        phoneReg = /^\d{8}$/;
        break;
      case '853': // 6开头后面跟7位数字
        phoneReg = /^[6]\d{7}$/;
        break;
      case '886': // 9(或09)开头后面跟8位数字
        phoneReg = /^([0]?[9])\d{8}$/;
        break;
      case '61': // 澳大利亚4(或04)开头, 后面跟8位数
        phoneReg = /^([0]?[4])\d{8}$/;
        break;
      case '44': // 英国电话号码是7(或07)开头的, 后面跟9位数
        phoneReg = /^([0]?[7])\d{9}/;
        break;
    }
    if (phoneReg) {
      return phoneReg.test(phone);
    }
    return true;
  }

  public validateConfirmPs(rule: any, value: string, callback: (err?: any) => void) {
    if (this.stepOneFormData.loginPs && this.stepOneFormData.loginPs !== value) {
      callback(new Error(this.$t('login.validPwdMsg') + ''));
    }
    callback();
  }

  // 获取验证码
  public async getVerification() {
    if (!this.checkEmailEmpty()) {
      return;
    }
    try {
      this.getVerificationLoading = true;
      const { data } = await sendEmailCodeApi(this.stepOneFormData.email);
      if (data.code === '1003') {
        this.countDownFlag = true;
        this.getVerificationLoading = false;
        this.setIntervalForVerify();
      }
    } catch (error) {
      this.getVerificationLoading = false;
    }
  }
  // 验证码定时器：60s内不能重复获取
  public setIntervalForVerify() {
    const countDownTimer = setInterval(() => {
      if (this.countDownNum === 1) {
        clearInterval(countDownTimer);
        this.countDownFlag = false;
        this.countDownNum = 60
        return;
      }
      this.countDownNum += -1;
    }, 1000);
    // 组件销毁前清理定时器
    this.$once('hook:beforeDestroy', () => {
      clearInterval(countDownTimer);
    })
  }
  // 检查电话或区号是否为空
  public checkEmailEmpty() {
    if (!this.stepOneFormData.email) {
      this.$message(this.$t('login.emailMsg') as string);
      return false;
    }
    return true;
  }

  // 获取国家
  public async getAllAreaCountryList() {
    if (this.countrys.length > 0) {
      this.countryOptions = this.countrys;
      return;
    }
    const { data } = await getAllAreaCountryListApi();
    this.countryOptions = data.datas;
    this.$emit('get-country-options', data.datas);
  }

  // 获取州省
  public async getByCountryId(id: number) {
    const { data } = await getByCountryIdApi(id);
    this.stateOptions = data.datas;
  }
  // 获取城市
  public async getByFkAreaStateId(id: number) {
    const { data } = await getByFkAreaStateIdApi(id);
    this.cityOptions = data.datas;
  }
  // 国家change事件
  public handleChangeCountry(id: number) {
    this.stateOptions = [];
    this.cityOptions = [];
    this.stepTwoFormData.fkAreaStateId = '';
    this.stepTwoFormData.fkAreaCityId = '';
    this.getByCountryId(id);
  }
  // 州省change事件
  public handleChangeState(id: number) {
    this.cityOptions = [];
    this.stepTwoFormData.fkAreaCityId = '';
    this.getByFkAreaStateId(id);
  }
  // 下一步
  public handleNextStep() {
    this.stepOneFormRef.validate((valid) => {
      if (valid) {
        this.isStepTwo = true;
      }
    })
  }
  // 上一步
  public handleLastStep() {
    this.isStepTwo = false;
  }
  // 注册
  public handleRegister() {
    this.stepTwoFormRef.validate((valid) => {
      if (valid) {
        this.stepOneFormData.loginId = this.stepOneFormData.email;
        const stepOneFormData = this.stepOneFormData
        const stepTwoFormData = this.stepTwoFormData
        delete stepOneFormData.confirmPs;
        const params: any = Object.assign({}, stepOneFormData, stepTwoFormData);
        params.requestUrlType = location.host;
        this.loading = true;
        gearRegisterApi(params).then(({ data }: any) => {
          this.loading = false;
          if (data.code === '1003') {
            this.$message({
              message: this.$t('login.registerSuccess') as string,
              type: 'success',
              duration: 2000,
              offset: 200,
              onClose: () => {
                this.$emit('to-login');
              }
            })
          }
        }).catch(() => {
          this.loading = false;
        })
      }
    })
  }
  // 清除表单校验
  public clearValidate() {
    this.stepOneFormRef.clearValidate();
    this.stepTwoFormRef.clearValidate();
  }
  // 重置表单
  public resetFormData() {
    this.stepOneFormRef.resetFields();
    this.stepTwoFormRef.resetFields();
  }
}
